export const BaseUrl = "https://jade-comfortable-kangaroo.cyclic.cloud";
